(function () {
  'use strict';
  var M = window.MONARCH || { routes: {}, strings: {} };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(c){ try{ return (c/100).toLocaleString('sv-SE',{style:'currency',currency:'SEK'}); }catch(e){ return (c/100).toFixed(0)+' kr'; } }

  /* Intro sequence */
  function initIntro(){
    var intro=document.querySelector('[data-intro]');
    if(!intro){ startReveals(); return; }
    if(reduce){ intro.remove(); startReveals(); return; }
    document.body.classList.add('intro-active');
    var hero=document.querySelectorAll('.hero .r');
    hero.forEach(function(el){ el.style.transitionDelay=''; });
    setTimeout(function(){ intro.classList.add('is-lit'); }, 1600);
    setTimeout(function(){
      intro.classList.add('is-done');
      document.body.classList.remove('intro-active');
      hero.forEach(function(el,i){ setTimeout(function(){ el.classList.add('in'); }, i*150); });
      setTimeout(function(){ if(intro && intro.parentNode) intro.parentNode.removeChild(intro); }, 1100);
      startReveals(true);
    }, 3000);
  }

  function startReveals(skipHero){
    var els = document.querySelectorAll('.r');
    if(reduce || !('IntersectionObserver' in window)){ els.forEach(function(el){ el.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function(ents,obs){
      ents.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); obs.unobserve(e.target); } });
    },{ threshold:.12, rootMargin:'0px 0px -60px 0px' });
    els.forEach(function(el){
      if(skipHero && el.closest('.hero')) return;
      io.observe(el);
    });
  }

  function initHeader(){
    var h = document.querySelector('[data-header]'); if(!h) return;
    var f = function(){ h.classList.toggle('is-scrolled', window.scrollY>8); };
    window.addEventListener('scroll', f, {passive:true}); f();
  }

  function initMenu(){
    var menu=document.querySelector('[data-mobile-menu]'), open=document.querySelector('[data-menu-open]');
    if(!menu||!open) return;
    open.addEventListener('click',function(){ menu.classList.add('is-open'); });
    document.querySelectorAll('[data-menu-close]').forEach(function(b){ b.addEventListener('click',function(){ menu.classList.remove('is-open'); }); });
    menu.querySelectorAll('a').forEach(function(a){ a.addEventListener('click',function(){ menu.classList.remove('is-open'); }); });
  }

  function initSwatches(){
    document.querySelectorAll('[data-product-form]').forEach(function(form){
      var input=form.querySelector('[data-variant-input]');
      var scope=form.closest('[data-section]')||document;
      var gallery=scope.querySelector('[data-gallery]');
      form.querySelectorAll('.swatch input').forEach(function(radio){
        radio.addEventListener('change',function(){
          if(input) input.value=radio.getAttribute('data-variant-id');
          form.querySelectorAll('.swatch').forEach(function(s){ s.classList.remove('is-active'); });
          var lab=radio.closest('.swatch'); if(lab) lab.classList.add('is-active');
          var fi=radio.getAttribute('data-featured-index');
          if(gallery && fi!==null){
            var thumb=gallery.querySelector('[data-thumb][data-index="'+fi+'"]');
            if(thumb) thumb.click();
          }
          var idx=radio.getAttribute('data-index');
          scope.querySelectorAll('[data-variant-image]').forEach(function(img){
            img.classList.toggle('is-active', img.getAttribute('data-variant-image')===idx);
          });
        });
      });
    });
  }

  function initFaq(){
    document.querySelectorAll('.faq__q').forEach(function(q){
      q.addEventListener('click',function(){
        var item=q.closest('.faq__item'), a=item.querySelector('.faq__a');
        var open=item.classList.toggle('open');
        q.setAttribute('aria-expanded', open?'true':'false');
        a.style.maxHeight = open ? a.scrollHeight+'px' : 0;
      });
    });
  }

  /* Cart */
  function openDrawer(){ var d=document.querySelector('[data-cart-drawer]'); if(d){ d.classList.add('is-open'); d.setAttribute('aria-hidden','false'); } }
  function closeDrawer(){ var d=document.querySelector('[data-cart-drawer]'); if(d){ d.classList.remove('is-open'); d.setAttribute('aria-hidden','true'); } }
  function freeShipHtml(total){
    var t=M.freeShip||0;
    if(!t) return '';
    if(total>=t){
      return '<div class="freeship freeship--done"><span class="freeship__msg">'+(M.strings.freeUnlocked||"You've unlocked free shipping")+' &#10003;</span><div class="freeship__track"><i style="width:100%"></i></div></div>';
    }
    var remain=t-total;
    var pct=Math.max(4,Math.min(99,Math.round(total/t*100)));
    var msg=(M.strings.freeProgress||'Add {{ amount }} more for free shipping').replace('{{ amount }}',money(remain));
    return '<div class="freeship"><span class="freeship__msg">'+msg+'</span><div class="freeship__track"><i style="width:'+pct+'%"></i></div></div>';
  }

  function render(cart){
    document.querySelectorAll('[data-cart-count]').forEach(function(c){ c.textContent=cart.item_count; });
    var body=document.querySelector('[data-cart-body]'), total=document.querySelector('[data-cart-total]');
    if(total) total.textContent=money(cart.total_price);
    if(!body) return;
    if(!cart.items.length){ body.innerHTML='<p style="color:var(--muted)">'+(M.strings.empty||'Your cart is empty.')+'</p>'; return; }
    var fs=freeShipHtml(cart.total_price);
    body.innerHTML=fs+cart.items.map(function(it){
      var img=it.image?it.image.replace(/(\.[a-z]+)(\?|$)/i,'_120x$1$2'):'';
      return '<div class="cd-item"><img src="'+img+'" alt="" width="62" height="62"><div>'+
        '<div style="font-family:var(--serif);font-size:1.1rem">'+it.product_title+'</div>'+
        '<div style="font-size:.8rem;color:var(--muted)">'+(it.variant_title||'')+'</div>'+
        '<div class="cd-qty" role="group" aria-label="Quantity">'+
          '<button type="button" data-qty="'+it.key+'" data-to="'+(it.quantity-1)+'" aria-label="Decrease">&minus;</button>'+
          '<span>'+it.quantity+'</span>'+
          '<button type="button" data-qty="'+it.key+'" data-to="'+(it.quantity+1)+'" aria-label="Increase">+</button>'+
        '</div>'+
        '<div style="font-size:.85rem;margin-top:4px">'+money(it.final_line_price)+'</div>'+
        '</div>'+
        '<a href="#" data-remove="'+it.key+'" aria-label="Remove">&times;</a></div>';
    }).join('');
    body.querySelectorAll('[data-remove]').forEach(function(a){
      a.addEventListener('click',function(e){ e.preventDefault(); change(a.getAttribute('data-remove'),0); });
    });
    body.querySelectorAll('[data-qty]').forEach(function(b){
      b.addEventListener('click',function(){ change(b.getAttribute('data-qty'), parseInt(b.getAttribute('data-to'),10)); });
    });
  }
  function refresh(){ return fetch(M.routes.cart,{headers:{'Accept':'application/json'}}).then(function(r){ if(!r.ok) throw new Error('cart '+r.status); return r.json(); }).then(render).catch(function(err){ console.error('Cart refresh failed:',err); }); }
  function change(key,qty){ fetch(M.routes.cartChange,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(render); }
  function initCart(){
    document.querySelectorAll('[data-product-form]').forEach(function(form){
      form.addEventListener('submit',function(e){
        e.preventDefault();
        var input=form.querySelector('[data-variant-input]'); var id=input?input.value:null; if(!id) return;
        var btn=form.querySelector('[data-add]');
        var span=btn?btn.querySelector('span'):null; var label=span?span.textContent:'';
        if(btn){ btn.disabled=true; } if(span){ span.textContent='Adding\u2026'; }
        fetch(M.routes.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(id,10),quantity:1}]})})
          .then(function(r){return r.json();}).then(function(){return refresh();})
          .then(function(){ if(span){ span.textContent='Added \u2713'; } openDrawer(); setTimeout(function(){ if(span) span.textContent=label; if(btn) btn.disabled=false; },1400); })
          .catch(function(err){console.error(err); if(span) span.textContent=label; if(btn) btn.disabled=false; });
      });
    });
    document.querySelectorAll('[data-buynow]').forEach(function(btn){
      btn.addEventListener('click',function(e){
        e.preventDefault();
        var form=btn.closest('[data-product-form]'); if(!form) return;
        var input=form.querySelector('[data-variant-input]'); var id=input?input.value:null; if(!id) return;
        btn.disabled=true;
        fetch(M.routes.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(id,10),quantity:1}]})})
          .then(function(r){return r.json();})
          .then(function(){ window.location.href=(M.routes.root||'/').replace(/\/$/,'')+'/checkout'; })
          .catch(function(err){console.error(err); btn.disabled=false;});
      });
    });
    document.querySelectorAll('[data-cart-open]').forEach(function(b){ b.addEventListener('click',function(e){ e.preventDefault(); refresh().then(openDrawer); }); });
    document.querySelectorAll('[data-cart-close]').forEach(function(b){ b.addEventListener('click',closeDrawer); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeDrawer(); });
  }

  function initParallax(){
    if(reduce) return;
    var el=document.querySelector('[data-parallax]'); if(!el) return;
    window.addEventListener('scroll',function(){ var y=window.scrollY; if(y<900) el.style.transform='translateY('+(y*0.05)+'px)'; },{passive:true});
  }


  function initProgress(){
    var bar=document.querySelector('[data-progress]'); if(!bar) return;
    var f=function(){ var h=document.documentElement; var max=h.scrollHeight-h.clientHeight; bar.style.width=(max>0?(h.scrollTop/max*100):0)+'%'; };
    window.addEventListener('scroll',f,{passive:true}); window.addEventListener('resize',f); f();
  }


  function initGallery(){
    document.querySelectorAll('[data-gallery]').forEach(function(g){
      var main=g.querySelector('[data-main]');
      var thumbs=g.querySelectorAll('[data-thumb]');
      thumbs.forEach(function(t){
        t.addEventListener('click',function(){
          var src=t.getAttribute('data-src'); if(src&&main) main.src=src;
          thumbs.forEach(function(x){ x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
    });
  }

  function initZoom(){
    if(reduce) return;
    document.querySelectorAll('[data-zoom]').forEach(function(z){
      var img=z.querySelector('img'); if(!img) return;
      z.addEventListener('mousemove',function(e){
        var r=z.getBoundingClientRect();
        var x=((e.clientX-r.left)/r.width)*100;
        var y=((e.clientY-r.top)/r.height)*100;
        img.style.transformOrigin=x+'% '+y+'%';
      });
      z.addEventListener('mouseenter',function(){ z.classList.add('zooming'); });
      z.addEventListener('mouseleave',function(){ z.classList.remove('zooming'); img.style.transformOrigin='center'; });
    });
  }


  function initCartPageQty(){
    document.querySelectorAll('[data-line-qty]').forEach(function(b){
      b.addEventListener('click',function(e){
        e.preventDefault();
        var line=b.getAttribute('data-line'); var to=b.getAttribute('data-to');
        fetch(M.routes.cartChange,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:parseInt(line,10),quantity:parseInt(to,10)})})
          .then(function(r){return r.json();}).then(function(){ window.location.reload(); });
      });
    });
  }

  document.addEventListener('DOMContentLoaded',function(){
    initIntro(); initProgress(); initHeader(); initMenu(); initSwatches(); initGallery(); initZoom(); initFaq(); initCart(); initCartPageQty(); initParallax(); refresh();
  });
})();
